import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'moet-core';

import StakeholderForm from './StakeholderForm';

const StakeholderFormCard = props => (
  <Card hasFooterLink={props.onRemove !== null} extraStyles={{ zIndex: 1 }}>
    <StakeholderForm {...props} />
    {props.children}
  </Card>
);

StakeholderFormCard.propTypes = {
  children: PropTypes.node,
  onRemove: PropTypes.func,
};

export default StakeholderFormCard;
